import * as config from '../../configs/config.json';

export const SERVER_URL = config.chime_endpoint || "https://in79nddqhg.execute-api.us-east-1.amazonaws.com/Prod/";
export const SERVER_REGION = "ca-central-1";

export function createMeetingRequest(meetingName, attendeeName) {
	let url = encodeURI(SERVER_URL + "/join?" + `title=${meetingName}&name=${attendeeName}&region=${SERVER_REGION}`);

	return fetch(url, { method: "POST" }).then((j) => j.json());
}